export default __webpack_public_path__ + "static/media/coordinator.8542dfe3.png";